import React, {useEffect} from 'react'
import {BrowserRouter, Switch, Route, useLocation, withRouter} from 'react-router-dom'

import {AnimatePresence} from 'framer-motion';
// AniamtePresence コンポーネントがReactツリーから削除されたときにアニメーション化する機能
// ドキュメント https://www.framer.com/docs/animate-presence/

import Home from './pages/Home'
import SingleWorkPD21 from './pages/SingleWorkPD21'
import SingleWorkID21 from './pages/SingleWorkID21'

import About from './pages/About'
import Page404 from './pages/404'

import ScrollTop from './components/ScrollTop'
import ScrollToTopOnMove from './components/ScrollToTopOnMove'
import usePageTracking from './usePageTracking';

function App() {

  const location = useLocation()
  usePageTracking();

  // ページ遷移時に一番上に戻る処理
  useEffect(() => { setTimeout(()=>{ window.scrollTo(0, 0) }, 500) }, [location])
  
  return (
    <BrowserRouter basename={"/oitid/student"}>
      <ScrollTop />
      <ScrollToTopOnMove />
      <AnimatePresence initial={true} exitBeforeEnter>
        <Switch>
          <Route exact path='/'><Home /></Route>
          <Route path='/works-PD2021-:workId'><SingleWorkPD21 /></Route>
          <Route path='/works-ID2021-:workId'><SingleWorkID21 /></Route>
          <Route path='*'><Page404 /></Route>
        </Switch>
      </AnimatePresence>
    </BrowserRouter>
  )
}

const WithRouterApp = withRouter(App);
export default WithRouterApp
